module.exports = __webpack_public_path__ + "img/supervisor_arrival-icon.a51cddd0.svg";